module.exports = __webpack_public_path__ + "files/ed31f7badcfe41e10e7831e9b22785ed.svg";